import { Chip, IconButton, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../assets/styles/tokens";
import RecentMonthTable from "./RecentMonthsTable";
import RecentWeeksTable from "./RecentWeeksTable";
import RecentFilter from "../RecentFilter/RecentFilter";

const monthTableHeadings = {
  metric: "",
  actual_target: "Actual / Target",
  gap: "Gap",
  attainment: "Attainment",
};
const monthTableRows = [
  {
    metric: "SPEND",
    actual_target: "$1,614,441 / $1,239,322",
    gap: "$375,119",
    attainment: "130.3%",
  },
  {
    metric: "PV",
    actual_target: "$394 / $399",
    gap: "-$5",
    attainment: "98.6%",
  },
  {
    metric: "PROFIT",
    actual_target: "$97,549 / $230,000",
    gap: "-$132,451",
    attainment: "42.4%",
  },
  {
    metric: "NRPU",
    actual_target: "$97,549 / $230,000",
    gap: "-$132,451",
    attainment: "-42.4%",
  },
  {
    metric: "FTD",
    actual_target: "4337/ 4337",
    gap: "-$132,451",
    attainment: "90%",
  },
  {
    metric: "CVR %",
    actual_target: "13.7% / 13.7%",
    gap: "-$132,451",
    attainment: "122%",
  },
  {
    metric: "CAC",
    actual_target: "$284 / $284",
    gap: "-$132,451",
    attainment: "55%",
  },
  {
    metric: "PROFIT",
    actual_target: "$349 / $349",
    gap: "-$132,451",
    attainment: "84.4%",
  },
];

const weeksTableHeadings = {
  metric: "",
  last_7_days: "Last 7 Days",
  days_7_14: "Days 7-14",
  trend: "Trend",
};
const weeksTableRows = [
  {
    metric: "SPEND",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "-24%",
  },
  {
    metric: "PROFIT",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "+25%",
  },
  {
    metric: "FTD",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "-19%",
  },
  {
    metric: "CVR %",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "-24%",
  },
  {
    metric: "CPC",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "-24%",
  },
  {
    metric: "CPA PV",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "+1%",
  },
  {
    metric: "CAC",
    last_7_days: "$252,085",
    days_7_14: "$252,085",
    trend: "-6%",
  },
];

const RecentTable = () => {
  return (
    <>
      <RecentFilter />

      <Typography
        sx={{
          fontWeight: typography.Font_weight.Medium.$value,
          color: colors.GrayLightMode[900].$value,
          my: 1,
        }}
      >
        Previous Month
      </Typography>
      <RecentMonthTable
        monthTableHeadings={monthTableHeadings}
        monthTableRows={monthTableRows}
      />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={3}
        mb={2}
      >
        <Chip
          sx={{
            fontSize: typography.Size.Text.sm.$value,
            fontWeight: typography.Font_weight.Semibold.$value,
            borderRadius: spacing.Radius.md.$value,
            backgroundColor: colors.GrayLightMode[50].$value,
            border: "1px solid " + colors.GrayLightMode[300].$value,
            color: colors.GrayLightMode[500].$value,
          }}
          label="08/11/2025 - 14/11/2025"
        />

        <IconButton aria-label="" color="default" size="small">
          <FileDownloadIcon sx={{ color: colors.GrayLightMode[700].$value }} />
        </IconButton>
      </Stack>
      <Typography
        sx={{
          fontWeight: typography.Font_weight.Medium.$value,
          color: colors.GrayLightMode[900].$value,
          my: 1,
        }}
      >
        Last 2 Weeks
      </Typography>
      <RecentWeeksTable
        weeksTableHeadings={weeksTableHeadings}
        weeksTableRows={weeksTableRows}
      />
    </>
  );
};

export default RecentTable;
